// extracted by mini-css-extract-plugin
export default {"panel":"project-allocation-panel_panel__HGF8j","toolbarInline":"project-allocation-panel_toolbarInline__42n0V"};